module.exports = __webpack_public_path__ + "img/Smart Mektep.ef0b3544.png";